import { appId } from '../branding';
import { Loading } from './Loading';

const DEFAULT_APP_ID = 'app-salonflow';

// O build de cada marca grava o nome no <title> do index.html. Lido uma unica vez, antes das telas alterarem o titulo.
const appName = appId === DEFAULT_APP_ID ? 'SalonFlow' : document.title.split('|')[0].trim() || 'SalonFlow';

export default function PageLoading() {
    return (
        <div className="sf-page-loading">
            <span className="sf-page-loading-name">{appName}</span>
            <Loading size="sm" />
        </div>
    );
}
